import React from 'react'
import PropTypes from 'prop-types'
import Button from 'components/shared/Button'
import AddressListing from 'components/shared/AddressListing'
import Link from 'components/shared/Link'
import Heading from 'components/shared/Heading'
import {Desktop} from 'components/shared/Responsive'
import {STATES} from 'lib/strings'

const EstateItem = ({estate, showBroker}) => {
  const stateKeys = Object.keys(STATES)
  const products = estate.products.edges
    .map(edge => edge.node)
    .sort((a, b) => stateKeys.indexOf(a.state) - stateKeys.indexOf(b.state))

  return (
    <AddressListing
      link={`/oppdrag/${estate.id}`}
      products={products}
      segment={estate.segment}
      address={estate.streetAddress}
      broker={showBroker && estate.broker ? estate.broker.name : null}
      actions={(
        <>
          <Desktop>
            <div className="tasks">
              {estate.tasks.length > 0 && (
                <>
                  <Heading level={4}>Oppgaver</Heading>
                  {estate.tasks.map((task, i) => (
                    <Link key={i} to={`/oppdrag/${estate.id}/produkt/${task.productId}`}>
                      {task.title}
                    </Link>
                  ))}
                </>
              )}
            </div>
          </Desktop>
          <Link to={`/oppdrag/${estate.id}`}>
            <Button type="navigation">Se oppdraget</Button>
          </Link>
        </>
      )}
    />
  )
}

EstateItem.propTypes = {
  estate: PropTypes.object,
  showBroker: PropTypes.bool,
}

export default EstateItem
